<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="$t('Cadastrar')"
        centered
        @hidden="cancelar"
        id="modal-cadastrar-evento"
    >
        <!-- TESTE {{ data }} -->
        <div class="row">
            <form-input v-model="titulo" label="Título teste" />
        </div>
        <div class="pt-0 d-flex justify-content-end">
            <button @click="submit" class="btn btn-primary m-0">
                Cadastrar
            </button>
        </div>
    </b-modal>
</template>
<script>
export default {
    name: "Add",
    props: ["data"],
    components: {},
    data() {
        return { titulo: "" };
    },
    mounted() {},
    methods: {
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$bvModal.hide("modal-cadastrar-evento");
        },
        submit() {
            let dados = {
                title: this.titulo,
                start: this.data.startStr,
                end: this.data.endStr
            };
            //console.log(dados);
            this.$emit("store", dados);
        }
    }
};
</script>
<style></style>
